// extracted by mini-css-extract-plugin
export default {"about":"styles_about__zq+yb","iconsList":"styles_iconsList__aRUBV","icon":"styles_icon__-AqWH"};